module.exports = __webpack_public_path__ + "img/Manuel-13.0ee456ac.jpg";